import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';
import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { useTracking } from '@change-corgi/core/react/tracking';

import { usePromotePageData } from 'src/app/pages/promote/pageContext';

type Result = ModelHookResult<
	{
		link: string;
		text: string;
	},
	{
		onClick: () => void;
	}
>;

export function useFooterLink(): Result {
	const { slug } = useKnownAvailableParams<{ slug: string }>();
	const {
		data: {
			featureConfigs: { useDonationLanguage },
		},
	} = usePromotePageData();
	const track = useTracking();
	const { translate } = useI18n();

	const text = useMemo(() => {
		const suffix = useDonationLanguage ? '_donation' : '';
		return translate(`corgi.co.promote.footer${suffix}`);
	}, [useDonationLanguage, translate]);

	return {
		data: {
			link: `/p/${slug}/psf/share?source_location=combo_psf`,
			text,
		},
		actions: {
			onClick: () => {
				void track('pp_form_skip_click');
			},
		},
	};
}
